import { cloneElement } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import styled from 'styled-components';

import AlertToast from './AlertToast';
import InfoToast from './InfoToast';
import SuccessToast from './SuccessToast';

const types = {
  alert: <AlertToast />,
  info: <InfoToast />,
  success: <SuccessToast />,
};

const ToastContainer = styled.div`
  position: fixed;
  top: 15px;
  right: 15px;
  z-index: 9;
`;

const ToastConductor = ({ toasts = [] }) => {
  const getToastComponent = type => types[type] || null;

  return (
    <ToastContainer>
      <ReactCSSTransitionGroup transitionName="toast" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
        {toasts.map(toast => {
          const Toast = getToastComponent(toast.type);

          return Toast
            ? cloneElement(Toast, {
                key: toast.id,
                id: toast.id,
                ...toast.options,
              })
            : null;
        })}
      </ReactCSSTransitionGroup>
    </ToastContainer>
  );
};

const stateToProps = state => state.toasts;

export default connect(stateToProps)(ToastConductor);
